import { ButtonHTMLAttributes, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

const variants = {
  primary: 'border-[#333333] text-[#333333]',
  secondary: 'text-[#F5F5F5] border-[#F5F5F5]',
  tertiary: 'bg-[#D4AF37] text-[#F5F5F5] border-0',
}
type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: () => void
  className?: string
  children?: ReactNode
  variant?: keyof typeof variants
}
export const Button = ({
  className,
  onClick,
  children,
  type = 'button',
  variant = 'primary',
}: ButtonProps) => {
  return (
    <button
      type={type}
      className={twMerge(
        'w-fit rounded-[5px] border-[1.5px]  px-[10px] py-[5px] font-nunito text-[12px] leading-[16.37px]  [font-weight:500] lg:rounded-[12px] lg:px-[25px]  lg:py-[10px] lg:text-[16px] md:text-[14px] md:leading-[19px] lg:font-[500] lg:leading-[21.82px]',
        className,
        variants[variant]
      )}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
